import { createContext, useContext, useEffect, useState } from "react";
import { content, isContentCompatible, mergeSiteContent } from "@/content";

const LanguageContext = createContext(null);
const STORAGE_KEY = "jo-lenz-lang";

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "en" ? "en" : "de";
    } catch {
      return "de";
    }
  });
  const [siteContent, setSiteContent] = useState(content);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((doc) => {
        // Altes/inkompatibles DB-Schema (z. B. Produktion vor Migration) wird ignoriert,
        // damit die Seite mit den gebündelten Inhalten stabil rendert statt leer zu bleiben.
        if (isContentCompatible(doc)) setSiteContent(mergeSiteContent(doc));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, lang);
    } catch {}
    document.documentElement.lang = lang;
    document.title = siteContent[lang].meta.title;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute("content", siteContent[lang].meta.description);
  }, [lang, siteContent]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t: siteContent[lang] }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
